import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const HevEnergyManagementGuidePage = () => <DataDrivenGuidePage slug="guide-hev-energy-management" />;

export default HevEnergyManagementGuidePage;
